"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _core = require("./core");

var _core2 = _interopRequireDefault(_core);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaultNamePat = /^simple\(.*\)/;

var combineStyles = function combineStyles(styles) {
    return styles.reduce(function (acc, style) {
        return Object.assign(acc, style);
    }, {});
};

var render = function render(self, Component, rule, _ref, altStyleName) {
    var style = _ref.style,
        className = _ref.className,
        otherProps = _objectWithoutProperties(_ref, ["style", "className"]);

    var makeDebugClass = function makeDebugClass(className) {
        return className && !defaultNamePat.test(className) ? className + "__" : null;
    };

    var mergedStyles = _extends({}, rule, style);

    var props = _extends({}, otherProps, {
        style: mergedStyles,
        className: (0, _classnames2.default)(makeDebugClass(self.displayName), makeDebugClass(altStyleName), className)
    });

    return _react2.default.createElement(Component, props);
};

exports.default = (0, _core2.default)(combineStyles, render);